import { render, staticRenderFns } from "./sticky-sidebar.vue?vue&type=template&id=95459d84&scoped=true"
import script from "./sticky-sidebar.vue?vue&type=script&lang=ts"
export * from "./sticky-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./sticky-sidebar.vue?vue&type=style&index=0&id=95459d84&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95459d84",
  null
  
)

export default component.exports